<script>
export default {
  name: "AEFinancesContainerIncomesPayExportInvoiceButton",
  template: `
    <gray-button
      v-if="paid"
      @click.prevent="payExportInvoice()"
      icon="fa-solid fa-ban"
      label="No pagada"
    />
    <success-button
      v-else
      @click.prevent="payExportInvoice()"
      icon="fa-solid fa-check-double"
      label="Pagada"
    />
  `,
  props: {
    paid: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    payExportInvoice: function () {
      this.$emit("payExportInvoice");
    }
  }
};
</script>
